import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TokenService } from '@utilities/services/token.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { environment } from '../../../environments/environment';

export const combinedInterceptor: HttpInterceptorFn = (req, next) => {
  let request = req;
  const allowedOrigins = environment.oktaConfig.allowedOrigins;
  const oktaToken = inject(OKTA_AUTH).getAccessToken();

  if (
    oktaToken &&
    !!allowedOrigins.find((origin) => req.url.includes(origin))
  ) {
    request = req.clone({
      setHeaders: { Authorization: `Bearer ${oktaToken}` },
    });
  }

  const tokenService = inject(TokenService);
  const token = tokenService.getToken();

  if (token) {
    request = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(request).pipe(
    catchError((response: HttpErrorResponse) => throwError(() => response))
  );
};
